export default __webpack_public_path__ + "static/media/emoji_tests.facbb2f5.svg";